export const getPositionStyles = (position, offset) => {
  switch (position) {
  case 'top':
    return { bottom: `calc(100% + ${offset}px)`, left: 0 };
  case 'bottom':
    return { top: `calc(100% + ${offset}px)`, left: 0 };
  case 'left':
    return { right: `calc(100% + ${offset}px)`, top: 0 };
  case 'right':
    return { left: `calc(100% + ${offset}px)`, top: 0 };
  default:
    return {};
  }
};
